"use client";

import { startTransition, useCallback, useContext } from "react";
import { AppRouterContext } from "next/dist/shared/lib/app-router-context.shared-runtime";

/**
 * Retry for an error boundary that caught a dropped connection: refetch the
 * route's server payload, then re-render the segment. `reset()` alone only
 * re-renders the client tree, which would replay the same failed fetch
 * result instead of asking the server again.
 *
 * Reads the router from context rather than `useRouter()`, which throws
 * when no app router is mounted: an error boundary must never throw while
 * rendering its own fallback. Without a router it falls back to `reset()`.
 */
export function useConnectionRetry(reset: () => void): () => void {
  const router = useContext(AppRouterContext);
  return useCallback(() => {
    startTransition(() => {
      router?.refresh();
      reset();
    });
  }, [router, reset]);
}
